import React from 'react';
import { BottomRightSection, BottomSection, Header, TopRightSection, TopSection, SubTitle } from './styles';
import { useSelector } from 'react-redux';
import { RootReducerInterface } from '../../interfaces/RootReducerInterface';
import { rootStore } from '../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import { ICON_COLORS } from '../../global/constants';
import { PROJECT_ICON_TYPE } from '../../global/constants';
import AddIconDropdown from '../viewCard/addIconDropdown';
import ProjectIconAvatar from '../ProjectIconAvtar/projectIconAvtar';
import { useMobileDevice } from '../../global/useMobile';

interface Props {
  subTitle?: string;
  Title: string;
  isInbox?: boolean;
  noMargin?: boolean;
  applyDottedText?: boolean;
  removeTitleSpacing?: boolean;
  leftElement?: React.ReactNode;
  isProjectDetail?: boolean;
}

const ResponsiveHeader: React.FC<Props> = ({
  subTitle,
  Title,
  isInbox = false,
  noMargin = false,
  applyDottedText,
  removeTitleSpacing,
  leftElement,
  isProjectDetail = false
}) => {
  // selector variables
  const stateSelector = useSelector((state: RootReducerInterface) => state);
  const { workspace: workspaceSelector } = stateSelector || {};
  const { workspace } = workspaceSelector;
  // other variables
  const isMobile = useMobileDevice();
  // Mobx variables
  const { projectStore, currentUser, appStore } = rootStore || {};
  const { currentProject } = projectStore;
  const { isPageScrolled } = appStore || {};

  return (
    <>
      <Header isInbox={isInbox} noMargin={noMargin}>
        <TopSection>
          <SubTitle>{isPageScrolled ? Title : subTitle || workspace?.name}</SubTitle>
          {/* {!disableSubtitleUpdate ? (
          ) : (
            <SubTitle>{subTitle ? subTitle : workspace?.name}</SubTitle>
          )} */}
          {/* animation code for text transition  */}
          {/* <HeaderTexts>
            <AnimatedSubTitle className={isPageScrolled ? 'scrolled' : ''}>
              {subTitle || workspace?.name}
            </AnimatedSubTitle>
            <AnimatedTitle className={isPageScrolled ? 'scrolled' : ''}>{Title}</AnimatedTitle>
          </HeaderTexts> */}
          <TopRightSection>{leftElement && leftElement}</TopRightSection>
        </TopSection>
      </Header>
      <BottomSection removeTitleSpacing={removeTitleSpacing} isInbox={isInbox} noMargin={noMargin}>
        {isProjectDetail &&
          (currentUser?.isAdmin || currentUser?.isOwner ? (
            <AddIconDropdown currentProject={currentProject!} />
          ) : (
            <ProjectIconAvatar
              size={isMobile ? 30 : 26}
              type={currentProject?.icon?.type ?? PROJECT_ICON_TYPE.DEFAULT}
              reference={currentProject?.icon?.reference || ''}
              backgroundColor={currentProject?.icon?.color ? ICON_COLORS[currentProject?.icon?.color] : ''}
              projectName={currentProject?.name || ''}
              iconSize={16}
            />
          ))}
        <BottomRightSection applyDottedText={applyDottedText}>{Title}</BottomRightSection>
      </BottomSection>
    </>
  );
};

export default observer(ResponsiveHeader);
